import React, { useState, useEffect } from "react";

export function usePublicChat({ me, urlParams}) {
  const [publicChatList, setPublicChatList] = useState(null);

  useEffect(() => {
    if (me && urlParams) {
      setPublicChatList({
        "public-chat": {
          props: {
            me,
            urlParams,
            key: `public-chat-${urlParams.pageSlug}`,
            type: "public",
            forceOpen: true,
          },
        },
      });
    }
  }, [me, urlParams]);

  return {
    publicChatList,
  };
}
